import { CgProfile } from "react-icons/cg";
import { PiProjectorScreen } from "react-icons/pi";
import { BiSolidContact } from "react-icons/bi";
import { AiFillHome } from "react-icons/ai";
import { useState, useEffect } from "react";
import { Link, animateScroll as scroll, scrollSpy } from 'react-scroll';

export default function Navbar() {
    const [theme, setTheme] = useState(localStorage.getItem("theme") ? localStorage.getItem("theme") : "light");
   
    useEffect(() => {
        localStorage.setItem("theme", theme);
        const localTheme = localStorage.getItem('theme');
        document.querySelector('html').setAttribute("data-theme", localTheme)
    },[theme]);

    const handleToggle = (e) => {
        if(e.target.checked){
            setTheme("dark");
        }else{
            setTheme('light');
        }
    }

  return (
    <div className="navbar-container w-fit fixed z-10">
      <ul className="navbar flex-col rounded-lg w-fit m-10 bg-black-100">
        <li className="hover:bg-indigo-500 hover:text-gray-300 hover:shadow-2xl rounded-full">
          <Link className="nav-link cursor-pointer p-3" to="home" smooth={true} duration={600}>
            <AiFillHome className="text-2xl"/>
          </Link>
        </li>
        <li className="hover:bg-indigo-500 hover:text-gray-300 hover:shadow-2xl rounded-full">
          <Link className="nav-link cursor-pointer p-3" to="about" smooth={true} duration={600}>
            <CgProfile className="text-2xl" />
          </Link>
        </li>
        <li className="hover:bg-indigo-500 hover:text-gray-300 hover:shadow-2xl rounded-full">
          <Link className="nav-link cursor-pointer p-3" to="portfolio" smooth={true} duration={600}>
            <PiProjectorScreen className="text-2xl" />
          </Link>
        </li>
        <li className="hover:bg-indigo-500 hover:text-gray-300 hover:shadow-2xl rounded-full">
          <Link className="nav-link cursor-pointer p-3" to="contact" smooth={true} duration={600}>
            <BiSolidContact className="text-2xl" />
          </Link>
        </li>
        
        <li className="hover:bg-indigo-500 hover:text-gray-300 hover:shadow-2xl rounded-full">
          <label className="swap swap-rotate p-3">
           
            <input type="checkbox" onChange={handleToggle} checked={theme === "light" ? false : true}/>
   
            <svg
              className="swap-on fill-current w-6 h-6 m-auto"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z" />
            </svg>

            <svg
              className="swap-off fill-current w-6 h-6 m-auto"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z" />
            </svg>
          </label>
        </li>
      </ul>
    </div>
  );
}
